databasesListItemController.$inject = [];
export default function databasesListItemController()
{
    var ctrl = this;

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.item = changes.item.currentValue;
        }
    };

    //
    //ctrl.select = function() {
    //    ctrl.onSelect(ctrl.item);
    //};

}

